import { Text } from '@ticketmaster/aurora';
import React from 'react';
import { ADDITIONAL_INFO } from './constant';

function formatAdditionalInfo(data: any, isFrontOfTicket: boolean): any {
  return (
    <div key={data.key}>
      <Text style={{ wordBreak: 'break-word' }}>
        {data.value}
      </Text>
      {isFrontOfTicket ? '' : <hr className="divider" />}
    </div>
    );
}

export function getAdditionalInfos(ticket: any, countryCode: String, isFrontOfTicket: boolean) : any {
  // @ts-ignore
  let keysToDisplay = ADDITIONAL_INFO[countryCode.toUpperCase()]
  if (countryCode.toUpperCase() === "IE") {
    if (isFrontOfTicket) {
      keysToDisplay = keysToDisplay["front"]
    } else {
      keysToDisplay = keysToDisplay["back"]
    }
  }
  if (keysToDisplay) {
    const additionalInfoToDisplay = ticket.additionalInfos.filter((data: any) => {
      return keysToDisplay.includes(data.key)
    })
    return additionalInfoToDisplay.sort((a: any, b: any) => {
      return keysToDisplay.indexOf(a.key) - keysToDisplay.indexOf(b.key)
    }).map((data: any) => {
      if (data.value) {
        return formatAdditionalInfo(data, isFrontOfTicket)
      }
      return null;
    })
  }
  else {
    return []
  }
}